import React, { useState, useMemo, useRef, useEffect } from "react";
import "./CorporateWellnessPageCss/CorporateAndEnquirySection.css";

//import { FaUser, FaPhoneAlt } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";

import {
  FaUser,
  FaPhoneAlt,
  FaBuilding,
  FaMapMarkerAlt,
  FaCommentDots,
} from "react-icons/fa";

import { sendMailByEnquiryForm } from "../../api/api";
import AnimatedText from "../../AnimatedText";
import toast from "react-hot-toast";

import redcliffe from "../../Assets/companies/redcliffe.png";
import shyamSteels from "../../Assets/companies/shyam steel.jpg";
import tata from "../../Assets/companies/tata 1mg.jpg";
import vguardd from "../../Assets/companies/vguardd.png";
import ekincare from "../../Assets/companies/ekincare.png";
import HealthAssure from "../../Assets/companies/HealthAssure.jpeg";
import intim from "../../Assets/companies/intim.jfif";
import medibuddy from "../../Assets/companies/medibuddy.png";
import nweptune from "../../Assets/companies/nweptune.png";
import youngIndians from "../../Assets/companies/young indians.png";
import pwc from "../../Assets/companies/pwc.jfif";

const companyLogos = [
  pwc,
  redcliffe,
  shyamSteels,
  tata,
  vguardd,
  youngIndians,
  ekincare,
  HealthAssure,
  intim,
  medibuddy,
  nweptune,
];

export default function CorporateAndEnquirySection() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [payload, setPayload] = useState({
    patientName: "",
    patientContactNo: "",
    patientEmail: "",
    companyName: "",
    location: "",
    serviceRequire: [], // empty array to store selected checkboxes
    message: "",
  });

  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 5;

  // ---------------------------
  // ✅ AUTO SLIDER ADDED HERE
  // ---------------------------
  useEffect(() => {
    const interval = setInterval(() => {
      setStartIndex((prev) => (prev + 1) % companyLogos.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const visibleLogos = [];
  for (let i = 0; i < Math.min(visibleCount, companyLogos.length); i++) {
    visibleLogos.push(companyLogos[(startIndex + i) % companyLogos.length]);
  }

  // ---------------------------

  const handlePrev = () => {
    setStartIndex(
      (prev) => (prev - 1 + companyLogos.length) % companyLogos.length
    );
  };
  const handleNext = () => {
    setStartIndex((prev) => (prev + 1) % companyLogos.length);
  };

  /*const validateForm = () => {
    const newErrors = {};
    if (!payload.name.trim()) newErrors.name = "Full name is required";
    if (!payload.email.trim()) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) newErrors.email = "Invalid email format";
    if (!payload.mobile.trim()) newErrors.mobile = "Mobile number is required";
    else if (!/^[0-9]{10}$/.test(payload.mobile)) newErrors.mobile = "Mobile number must be 10 digits";
    if (!payload.message.trim()) newErrors.message = "Message is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };*/

  const validateForm = () => {
    const newErrors = {};

    if (!payload.patientName.trim())
      newErrors.patientName = "Full name is required";
    else if (!/^[a-zA-Z\s]+$/.test(payload.patientName))
      newErrors.patientName = "Name can only contain letters and spaces";

    if (!payload.patientEmail.trim())
      newErrors.patientEmail = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.patientEmail))
      newErrors.patientEmail = "Invalid email format";

    if (!payload.patientContactNo.trim())
      newErrors.patientContactNo = "Mobile number is required";
    else if (!/^[0-9]{10}$/.test(payload.patientContactNo))
      newErrors.patientContactNo = "Mobile number must be 10 digits";

    if (!payload.location.trim()) newErrors.location = "Location is required";
    else if (!/^[a-zA-Z\s]+$/.test(payload.location))
      newErrors.location = "Location can only contain letters and spaces";

    if (!payload.companyName.trim())
      newErrors.companyName = "Company Name is required";
    else if (!/^[a-zA-Z\s]+$/.test(payload.companyName))
      newErrors.companyName =
        "Company Name can only contain letters and spaces";

    if (payload.serviceRequire.length === 0)
      newErrors.serviceRequire = "At least one service must be selected";

    if (!payload.message.trim()) newErrors.message = "Message is required";
    else if (payload.message.trim().length < 10)
      newErrors.message = "Message must be at least 10 characters long";
    else if (!/^[a-zA-Z\s]+$/.test(payload.message))
      newErrors.message = "Message can only contain letters and spaces";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let filteredValue = value;

    if (["patientName", "companyName", "location", "message"].includes(name)) {
      filteredValue = value.replace(/[^a-zA-Z\s]/g, "");
    }

    setPayload((prev) => ({ ...prev, [name]: filteredValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    try {
      const res = await sendMailByEnquiryForm(payload);

      // API response you shared:
      // { "status": "Success", "responseCode": 200, "message": "Thank you..." }

      if (res?.data?.status === "Success") {
        toast.success(res?.data?.message);

        // reset form
        setPayload({
          patientName: "",
          patientContactNo: "",
          patientEmail: "",
          companyName: "",
          location: "",
          serviceRequire: [],
          message: "",
        });
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Server error");
    } finally {
      setLoading(false);
    }
  };

  /*const fetchsendMailByEnquiryForm = async (data) => {
    try {
      setLoading(true);
      setMessage("");
      const res = await sendMailByEnquiryForm(data);
      // ✔ Handle success response
      if (res?.data?.status === "Success") {
        toast.success(res?.data?.message);
  
        // Reset form
        setPayload({
          patientName: "",
          patientContactNo: "",
          patientEmail: "",
          companyName: "",
          location: "",
          serviceRequire: [],
          message: ""
        });
  
        setErrors({});
      } 
      else {
        toast.error("Something went wrong. Please try again.");
      }
  
    } catch (err) {
      toast.error(
        err?.response?.data?.message || 
        "Server error. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };*/

  const scrollRef = useRef(null);
  const scrollLeft = () =>
    scrollRef.current && (scrollRef.current.scrollLeft -= 300);
  const scrollRight = () =>
    scrollRef.current && (scrollRef.current.scrollLeft += 300);

  //checkbox function
  const handleCheckboxChange = (value) => {
    setPayload((prev) => {
      const isSelected = prev.serviceRequire.includes(value);

      return {
        ...prev,
        serviceRequire: isSelected
          ? prev.serviceRequire.filter((item) => item !== value) // remove unchecked
          : [...prev.serviceRequire, value], // add checked
      };
    });
  };
  console.log(payload);
  return (
    <>
      <div className="corporateAndEnquiryContainer">
        {/* LEFT SECTION */}
        <div className="ceLeftSection">
          <AnimatedText
            tag="h2"
            type="words"
            y={30}
            className="WellnessHeading"
          >
            {/*Corporate & Institutional Wellness Services*/}
          </AnimatedText>

          <p>
            At <b>RB Diagnostic,</b> we partner with organizations, communities,
            and healthcare institutions to deliver accessible, reliable, and
            high-quality diagnostic and wellness solutions. Our services are
            designed to promote preventive healthcare, early detection, and
            convenient access to medical facilities across Kolkata.
          </p>

          <h1>1. Corporate & TPAs :</h1>
          <h3>“Healthy Employees Stronger Organizations”</h3>
          {/* <h2>Comprehensive Health Solutions for Companies & Employees</h2>*/}
          <p>
            We work with Corporates and TPAs to offer seamless, end-to-end
            diagnostic support that boosts employee well-being and
            organizational productivity.
          </p>

          <h3>Services Offered:</h3>
          <ul class="arrow-list">
            <li>
              <p>
                <b>Annual / Pre-Employment Health Check-ups</b> Customized
                panels as per corporate requirements.
              </p>
            </li>
            <li>
              <p>
                <b>TPA Coordination Support</b> Hassle-free processing for
                insured employees including cashless check-ups (where
                applicable).
              </p>
            </li>
            <li>
              <p>
                <b>Customized Corporate Wellness Packages</b> Tailored solutions
                for employee groups of all sizes.
              </p>
            </li>
            <li>
              <p>
                <b>On-Site Health Camps</b> Complete health screenings, blood
                tests, and preventive packages at your office.
              </p>
            </li>
            <li>
              <p>
                <b>Doctor Consultations</b> General physicians or specialists
                for specific health drives.
              </p>
            </li>
          </ul>

          <h1>2. Residential Camps :</h1>
          <h3>“Bringing Quality Healthcare to Your Doorstep”</h3>
          {/*<h2>Health Camps at Housing Societies & Residential Complexes</h2>
        <p>RB Diagnostic organizes health camps to promote preventive healthcare in communities.</p>*/}

          <h3>Services Offered:</h3>
          <ul class="arrow-list">
            <li>
              <p>
                <b>On-Site Diagnostic Camps</b> with blood tests and essential
                screenings.
              </p>
            </li>
            <li>
              <p>
                <b>Doctor Check-Ups</b> general health assessments for
                residents.
              </p>
            </li>
            <li>
              <p>
                <b>Specialized Awareness Camps</b>diabetes, cardiac, women’s
                health, senior wellness.
              </p>
            </li>
            <li>
              <p>
                <b>Seamless Sample Collection & Reporting</b>Trained
                phlebotomists, quick sample processing, and fast digital
                reports.
              </p>
            </li>
          </ul>

          <h1>3. Diagnostic Partnerships for SMEs & Nursing Homes :</h1>
          <h3>“Strengthening Clinics with Advanced Diagnostics”</h3>
          {/*<h2>Radiology & Pathology Support for Healthcare Providers</h2>
        <p>We serve as an extended diagnostic arm to small labs, clinics, and nursing homes.</p>*/}

          <h3>Services Offered:</h3>
          <ul class="arrow-list">
            <li>
              <p>
                <b>Radiology Services</b> X-Ray, USG, ECG, 2D Echo, CT/MRI
                support (as applicable).
              </p>
            </li>
            <li>
              <p>
                <b>Pathology Services</b>Full-range laboratory testing with
                accurate reporting.
              </p>
            </li>
            <li>
              <p>
                <b>Ambulance Pick-UP & Drop</b>For patient transport(if
                required)
              </p>
            </li>
            <li>
              <p>
                <b>Technical & Logistics Support</b> Software, rapid TAT with
                quality assurance processes, and sample pickup/drop support.
              </p>
            </li>
          </ul>

          <h1>4. Visa Medical Pre-Test Services :</h1>
          <h3>“Your Trusted Partner for Visa Medical Pre-Tests”</h3>
          {/*<h2> Approved Diagnostic Services for Visa Requirements</h2>
        <p>We offer approved diagnostic services required for visa applications.</p>*/}

          <h3>Services Offered:</h3>
          <ul class="arrow-list">
            <li>
              <p>Mandatory blood investigations</p>
            </li>
            <li>
              <p>Chest X-Ray</p>
            </li>
            <li>
              <p>Tuberculosis screening</p>
            </li>
            <li>
              <p>
                Physical fitness exams certified by Registered Medical
                Practitioners
              </p>
            </li>
            <li>
              <p>Quick turnaround for urgent visa needs</p>
            </li>
          </ul>

          {/* Slider
          <div className="company-slider-section">
            <div className="company-slider-wrapper">
              <div className="company-slider">
                {visibleLogos.map((logo, idx) => (
                  <div className="company-logo" key={`${logo}-${idx}`}>
                    <img src={logo} alt={`company-${idx}`} />
                  </div>
                ))}
              </div>

              <button className="slide-btn right" onClick={handleNext}>›</button>
            </div>
          </div> */}
        </div>

        {/* RIGHT – FORM */}
        <div className="ceRightSectionContent">
          <AnimatedText tag="h1" type="words" y={30}>
            Enquiry Form
          </AnimatedText>

          <div className="ceRightSection">
            <form onSubmit={handleSubmit} className="enquiryForm">
              {/* Name */}
              <div className="input-icon-group">
                <FaUser className="input-icon" />
                <input
                  type="text"
                  name="patientName"
                  placeholder="Name"
                  value={payload.patientName}
                  onChange={handleInputChange}
                />
                {errors.patientName && (
                  <p className="error-text">{errors.patientName}</p>
                )}
              </div>

              {/* Mobile */}
              <div className="input-icon-group">
                <FaPhoneAlt className="input-icon" />
                <input
                  type="tel"
                  name="patientContactNo"
                  placeholder="Mobile Number"
                  value={payload.patientContactNo}
                  onChange={handleInputChange}
                  maxLength={10}
                  pattern="[0-9]{10}"
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                  }
                />
                {errors.patientContactNo && (
                  <p className="error-text">{errors.patientContactNo}</p>
                )}
              </div>

              {/* Email */}
              <div className="input-icon-group">
                <IoMdMail className="input-icon" />
                <input
                  type="email"
                  name="patientEmail"
                  placeholder="Email"
                  value={payload.patientEmail}
                  onChange={handleInputChange}
                />
                {errors.patientEmail && (
                  <p className="error-text">{errors.patientEmail}</p>
                )}
              </div>

              {/* Company Name */}
              <div className="input-icon-group">
                <FaBuilding className="input-icon" />
                <input
                  type="text"
                  name="companyName"
                  placeholder="Company Name"
                  value={payload.companyName}
                  onChange={handleInputChange}
                />
              </div>

              {/* Location / City */}
              <div className="input-icon-group">
                <FaMapMarkerAlt className="input-icon" />
                <input
                  type="text"
                  name="location"
                  placeholder="Location / City"
                  value={payload.location}
                  onChange={handleInputChange}
                />
                {errors.companyName && (
                  <p className="error-text">{errors.companyName}</p>
                )}
              </div>

              {/*checkbox*/}
              <label className="form-label">Service Require *</label>

              <div className="custom-checkbox-group">
                {[
                  "Pre-employment Check-up",
                  "Annual Health Check-up",
                  "Others",
                ].map((service) => (
                  <label key={service} className="custom-checkbox">
                    <input
                      type="checkbox"
                      value={service}
                      checked={payload.serviceRequire.includes(service)}
                      onChange={() => handleCheckboxChange(service)}
                    />
                    <span className="checkmark"></span>
                    <span className="checkbox-text">{service}</span>
                  </label>
                ))}
                {errors.serviceRequire && (
                  <p className="error-text">{errors.serviceRequire}</p>
                )}
              </div>

              {/* Message */}
              <div className="input-icon-group">
                <FaCommentDots className="input-icon" />
                <textarea
                  className="message"
                  name="message"
                  placeholder="Message"
                  rows="4"
                  value={payload.message}
                  onChange={handleInputChange}
                ></textarea>

                {errors.message && (
                  <p className="error-text">{errors.message}</p>
                )}
              </div>

              {/* Submit */}

              {/* <button type="submit" className="rbdButton" disabled={loading}>
  {loading ? (
    <div className="loader"></div>
  ) : (
    <span className="btn-text">Submit</span>
  )}
</button> */}

              <button type="submit" className="rbdButton">
                <span className="btn-text">Submit</span>
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Slider */}
      <div className="company-slider-section">
        <div className="company-slider-wrapper">
          <div className="company-slider">
            {visibleLogos.map((logo, idx) => (
              <div className="company-logo" key={`${logo}-${idx}`}>
                <img src={logo} alt={`company-${idx}`} />
              </div>
            ))}
          </div>

          <button className="slide-btn right" onClick={handleNext}>
            ›
          </button>
        </div>
      </div>
    </>
  );
}
